import * as Yup from "yup";

const ordemServicoValidator = (importacao, id) => {
  return Yup.object().shape({
    status: Yup.string().nullable(),
    clienteId: Yup.number()
      .transform((value) => (Number.isNaN(value) ? undefined : value))
      .required("Cliente"),
    clienteNome: Yup.string().nullable(),
    clienteEmail: Yup.string().email("Email inválido").nullable(),
    clienteCnpjCpf: Yup.string().nullable(),
    dataAbertura: Yup.date()
      .nullable()
      .transform((curr, orig) => (orig === "" ? null : curr))
      .required("Data de Abertura"),
    dataPrevistaFechamento: Yup.date()
      .nullable()
      .transform((curr, orig) => (orig === "" ? null : curr))
      .required("Data Prevista de Fechamento")
      .test(
        "data-posterior",
        "A data prevista não pode ser anterior à data de abertura",
        function (value) {
          const { dataAbertura } = this.parent;
          if (!dataAbertura || !value) return true;
          return new Date(value) >= new Date(dataAbertura);
        },
      ),
    observacoes: Yup.string().nullable(),
    orcamentoServicoId: importacao
      ? Yup.number().required("Vínculo do Orçamento de Serviço")
      : Yup.number().nullable(),
    servicos: Yup.array()
      .transform((value) => (Array.isArray(value) ? value : []))
      .when("status", {
        is: (status) => !!id && status === "FECHADO",
        then: (schema) => schema.min(1, "Incluir ao menos 1 serviço"),
        otherwise: (schema) => schema,
      }),
    ativos: Yup.array()
      .of(
        Yup.object().shape({
          ativoId: Yup.number().required(),
          nome: Yup.string(),
          valoresCampos: Yup.array().test(
            "validar-campos-obrigatorios",
            "Campos obrigatórios não preenchidos",
            function (valoresCampos) {
              const { camposPersonalizados, nome } = this.parent;
              if (!camposPersonalizados || !Array.isArray(camposPersonalizados)) {
                return true;
              }
              const camposFaltantes = [];
              camposPersonalizados.forEach((campoDef) => {
                if (campoDef.obrigatoriedade) {
                  const valorEntry = valoresCampos?.find(
                    (v) => v.campoPersonalizadoId === campoDef.id,
                  );
                  const valor = valorEntry ? valorEntry.valor : "";
                  if (valor === "" || valor === null || valor === undefined) {
                    camposFaltantes.push(
                      campoDef.nome || campoDef.label || "Campo sem nome",
                    );
                  }
                }
              });
              if (camposFaltantes.length > 0) {
                return this.createError({
                  message: `No ativo "${
                    nome || "Item"
                  }", preencha: ${camposFaltantes.join(", ")}`,
                  path: this.path,
                });
              }
              return true;
            },
          ),
        }),
      )
      .nullable(),
  });
};

export default ordemServicoValidator;
